import React from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation, useParams, useSearchParams} from "react-router-dom";
import { FormattedMessage, useIntl  } from 'react-intl';

import { Tabs } from 'antd';

import { COMPUTERS_PATH } from '../utils/constants';
import BreadcrumbHeader from './BreadcrumbHeader';
import ReportsFilter from './ReportsFilter';
import DetailedReport from './DetailedReport';
import ComputerReportGeneral from './ComputerReportGeneral';
import {getPrinterDetailedColumns} from './GetDetailedColumns';

const ComputerReport = (props) => {

    let params = useParams();
    const compId = parseInt(params['id'], 10);

    const location = useLocation();
    const intl = useIntl();

    const [searchParams] = useSearchParams();
    const serverId = searchParams.get("serverId")

    let filterData = useSelector(state => state.reportFilter);
    let computers = useSelector(state => state.computersCache);
    let servers = useSelector(state => state.serversCache);
    
    if (!compId)
    {
        return(
            <div><h3>Bad computer Id</h3></div>
        );
    }

    let compName = computers[compId] ? computers[compId] : "Computer id = " + compId;
    let serverName = (serverId && servers[serverId]) ? servers[serverId] : null

return (
        <div>
            <div className = "filter-report-picker">
                <ReportsFilter/>
            </div>
            <BreadcrumbHeader
                location = {location}
                objectLink = {compName}
                server = {serverName}
                rootPath = {COMPUTERS_PATH}
                pathName = "Computer"
            />
            <br/>
                <Tabs defaultActiveKey="1" type="card">
                    <Tabs.TabPane tab={intl.formatMessage({ id: "LeftMenu.Submenu.general" })} key="1">
                        <ComputerReportGeneral compId = {compId} filterData = {filterData}/>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={intl.formatMessage({ id: "Detailed" })} key="2">
                    <DetailedReport 
                            api_url = {"/job?computerId=" + compId} 
                            columns = {getPrinterDetailedColumns()}
                            filterData = {filterData}
                        />
                    </Tabs.TabPane>
                </Tabs>
                <Link to={COMPUTERS_PATH}><FormattedMessage id="Back"/></Link>
        </div>);
}

export default ComputerReport;